import { useState } from 'react';
// routes
import { useRouter, useSearchParams } from 'src/routes/hooks';
import { paths } from 'src/routes/paths';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export const GuestGuard = ({ children }: Props) => {
  const router = useRouter();

  const [checked, setChecked] = useState(false);

  // const auth = useRecoilValue(authStore);

  const searchParams = useSearchParams();

  const returnTo = searchParams.get('returnTo') || paths.dashboard.root;

  // const check = useCallback(() => {
  //   if (auth && auth.email) {
  //     router.replace(returnTo);
  //   } else {
  //     setChecked(true);
  //   }
  // }, [auth, returnTo, router]);

  // useEffect(() => {
  //   check();
  // }, [check]);

  // if (!checked) {
  //   return null;
  // }

  return <>{children}</>;
};
